import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Home, Gauge, Upload } from 'lucide-react';

const navItems = [
  { path: '/tenant/mobile', label: 'Home', icon: Home },
  { path: '/tenant/mobile/mileage', label: 'Mileage', icon: Gauge },
  { path: '/tenant/mobile/receipts', label: 'Receipts', icon: Upload },
];

/**
 * Mobile-first layout with bottom navigation bar.
 * No sidebar; full-width content with fixed bottom nav.
 * Used for tenant mobile interface at /tenant/mobile.
 */
export default function MobileLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => {
    if (path === '/tenant/mobile') {
      return location.pathname === '/tenant/mobile';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100">
      {/* Optional compact header */}
      <header className="flex-shrink-0 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-3">
        <h1 className="text-base font-semibold text-gray-900 dark:text-gray-100">SparxMate Mobile</h1>
      </header>

      {/* Scrollable main content with padding for bottom nav */}
      <main className="flex-1 overflow-auto pb-20">
        <Outlet />
        <footer className="border-t border-gray-200 dark:border-gray-700 py-3 mt-auto">
          <p className="text-center text-xs text-gray-500 dark:text-gray-400">
            Powered by SparxMate{typeof __APP_VERSION__ !== 'undefined' && <span className="ml-1 opacity-75">v{__APP_VERSION__}</span>}
          </p>
        </footer>
      </main>

      {/* Bottom navigation bar - fixed with safe-area padding */}
      <nav
        className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]"
        role="navigation"
      >
        <div className="flex justify-around items-center">
          {navItems.map(({ path, label, icon: Icon }) => {
            const active = isActive(path);
            return (
              <button
                key={path}
                type="button"
                onClick={() => navigate(path)}
                className={`flex flex-col items-center justify-center min-w-[44px] min-h-[44px] px-4 rounded-lg transition-colors ${
                  active
                    ? 'text-blue-600 dark:text-blue-400'
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
                }`}
                aria-label={label}
                aria-current={active ? 'page' : undefined}
              >
                <Icon className="w-6 h-6" aria-hidden />
                <span className="text-xs mt-0.5">{label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
